const JOB_STATUS_LABELS = {
  requested: 'Requested',
  confirmed: 'Confirmed',
  finding_vendor: 'Finding vendor',
  assigned: 'Assigned',
  in_progress: 'In progress',
  completed: 'Completed',
  cancelled: 'Cancelled',
  closed: 'Closed',
};

const ONBOARDING_STATUS_LABELS = {
  invite_pending: 'Invite pending',
  draft: 'In progress',
  pending_approval: 'Pending approval',
  approved: 'Approved',
  rejected: 'Rejected',
};

export { JOB_STATUS_LABELS, ONBOARDING_STATUS_LABELS };
